import { render, staticRenderFns } from "./userIcon.vue?vue&type=template&id=e9f13b5e&scoped=true&"
import script from "./userIcon.vue?vue&type=script&lang=js&"
export * from "./userIcon.vue?vue&type=script&lang=js&"
import style0 from "./userIcon.vue?vue&type=style&index=0&id=e9f13b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f13b5e",
  null
  
)

export default component.exports